import type { HTMLAttributes } from 'react';

import { ScrollHintButton } from '@/components/ScrollHintButton';

import { cn } from '@/lib/utils';

import { useScrollHint } from '@/hooks';

type ScrollHintAreaProps = Omit<HTMLAttributes<HTMLDivElement>, 'onScroll'>;

export const ScrollHintArea = (props: ScrollHintAreaProps) => {
  const { children, className, ...rest } = props;
  const { scrollRef, scrollHint, onScrollEdgesUpdate, onScrollJump } =
    useScrollHint();

  return (
    <div className="relative min-h-0 flex-1 overflow-hidden">
      <div
        ref={scrollRef}
        onScroll={onScrollEdgesUpdate}
        className={cn('h-full overflow-y-auto', className)}
        {...rest}
      >
        {children}
      </div>
      <ScrollHintButton
        hint={scrollHint}
        onJump={onScrollJump}
      />
    </div>
  );
};
